import { debounce as _debounce } from 'lodash';

import { listPharmacies } from './index';

export default _debounce(listPharmacies, 350);
